/* eslint-disable prettier/prettier */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { formatDateTimeBr } from '../utils/datetime';
import ApiStatusBadge from '../components/ApiStatusBadge';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  LinearProgress,
  CircularProgress,
  IconButton,
  Tooltip,
  TextField,
  Alert,
  Chip,
  Divider,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import TestesModal from '../components/TestesModal';
import ConsultaRelatoriosModal from '../components/ConsultaRelatoriosModal';
import DiarioDeObraIntegration from '../components/DiarioDeObraIntegration';
import RecebimentoOSModal from '../components/RecebimentoOSModal';
import ConsultaRecebimentoOSModal from '../components/ConsultaRecebimentoOSModal';
import { AccessLogModal } from '../components/AccessLogCard';
import AgendaModal from '../components/AgendaModal';
import FluxoCronogramaModal from '../components/FluxoCronogramaModal';
import {
  Construction,
  People,
  AttachMoney,
  ExitToApp,
  Storefront,
  Assessment,
  Search,
  Security,
  ReceiptLong,
  Download as DownloadIcon,
  Refresh as RefreshIcon,
  Delete as DeleteIcon,
  CloudDownload as CloudDownloadIcon,
  History as HistoryIcon,
  Backup as BackupIcon,
  CloudUpload as CloudUploadIcon,
  SupportAgent,
  SmartToy,
  Cached as CachedIcon,
  Notifications as NotificationsIcon,
  CloudSync as CloudSyncIcon,
  CalendarMonth,
  ViewColumn,
  ReportProblem,
  CloudQueue as GDriveIcon,
  Devices as DevicesIcon,
} from '@mui/icons-material';

import { useAuth } from '../contexts/AuthContext';
import { EstruturaSeguranca } from './Estrutura';
import ConsultaChamadosModal from './ConsultaChamadosModal';
import AbrirChamado from './AbrirChamado';

const clearCache = () => {
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }
  window.localStorage.removeItem('user'); // Opcional: logout ao limpar cache? vou manter logout
  window.localStorage.removeItem('token');
  window.location.reload(true);
};

export default function DashboardHome() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, token, hasPermission, isAdmin, isManutencao, isGestor, isSupervisor, isTecnico, isCliente, logout } = useAuth();
  const API = '/api';
  const agentWarmupRef = useRef(false);
  // Tamanho fixo dos cards 150x150 px
  const CARD_HEIGHT = 150;
  // Área de ação bem compacta para caber no card 150x150 com avatar 60
  const ACTION_AREA_HEIGHT = { xs: 20, sm: 20 };
  // Ajuste dinâmico de fonte para títulos longos (2 linhas)
  const getTitleSx = (title) => {
    const len = (title || '').length;
    let fontSize = { xs: '0.9rem', sm: '1rem' };
    
    if (len > 25) {
      fontSize = { xs: '0.75rem', sm: '0.85rem' };
    } else if (len > 18) {
      fontSize = { xs: '0.8rem', sm: '0.9rem' };
    } else if (len > 12) {
      fontSize = { xs: '0.85rem', sm: '0.95rem' };
    }
    
    return {
      fontWeight: 700,
      fontSize,
      lineHeight: 1.1,
      // display: '-webkit-box', // Conflita com display: flex abaixo
      // WebkitLineClamp: 2,
      // WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      // Altura do título ajustada para 2 linhas
      height: { xs: 36, sm: 36 },
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    };
  };

  const [, setTestesCount] = useState(null);
  // Contadores detalhados não exibidos nesta versão simplificada
  const [openTestesModal, setOpenTestesModal] = useState(false);
  const [openConsultaRelatoriosModal, setOpenConsultaRelatoriosModal] = useState(false);
  const [openRecebimentoModal, setOpenRecebimentoModal] = useState(false);
  const [openConsultaRecebimentoModal, setOpenConsultaRecebimentoModal] = useState(false);
  const [openAccessLogModal, setOpenAccessLogModal] = useState(false);
  const [openAgendaModal, setOpenAgendaModal] = useState(false);
  const [openEstruturaDialog, setOpenEstruturaDialog] = useState(false);
  const [openConsultaChamadosModal, setOpenConsultaChamadosModal] = useState(false);
  const [openAbrirChamadoModal, setOpenAbrirChamadoModal] = useState(false);
  const [abrirChamadoPrefill, setAbrirChamadoPrefill] = useState(null);
  const [openEstruturaSeguranca, setOpenEstruturaSeguranca] = useState(false);
  const [openFluxoCronogramaModal, setOpenFluxoCronogramaModal] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [selectedClienteId, setSelectedClienteId] = useState('');

  const [hasPendentes, setHasPendentes] = useState(false);
  const [openPendentes, setOpenPendentes] = useState(false);
  // Chamados: contador de abertos para sino de notificação
  const [chamadosAbertos, setChamadosAbertos] = useState(0);
  const [emergenciasPendentes, setEmergenciasPendentes] = useState(0);
  const [chamadosLoaded, setChamadosLoaded] = useState(false);
  const [isEmergencyFlow, setIsEmergencyFlow] = useState(false);
  const [openOnlineCheckDialog, setOpenOnlineCheckDialog] = useState(false);
  const onlineCheckTimerRef = useRef(null);
  // Backup
  const [_backupStatus, setBackupStatus] = useState(null);
  const [_loadingBackup, setLoadingBackup] = useState(false);
  const [backupsModalOpen, setBackupsModalOpen] = useState(false);
  const [backups, setBackups] = useState([]);
  const [fullBackups, setFullBackups] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(new Set());
  const [creatingBackup, setCreatingBackup] = useState(false);
  const [creatingFullBackup, setCreatingFullBackup] = useState(false);
  const [creatingApiBackup, setCreatingApiBackup] = useState(false);
  const [apiBackups, setApiBackups] = useState([]);
  const [fullBackupProgress, setFullBackupProgress] = useState(null);
  const [apiProgress, setApiProgress] = useState(null);
  const [apiBackupCurrentPart, setApiBackupCurrentPart] = useState(0);
  const [downloadingBackup, setDownloadingBackup] = useState(null);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [backupMessage, setBackupMessage] = useState('');
  const [backupError, setBackupError] = useState('');

  useEffect(() => {
    if (!location.state?.openAbrirChamadoModal) return;

    setAbrirChamadoPrefill(location.state?.chamadoPrefill || null);
    setOpenAbrirChamadoModal(true);
    navigate(location.pathname, { replace: true, state: null });
  }, [location.pathname, location.state, navigate]);

  const closeAbrirChamadoModal = useCallback(() => {
    setOpenAbrirChamadoModal(false);
    setAbrirChamadoPrefill(null);
    setIsEmergencyFlow(false);
  }, []);
  
  // Estados para importação de backup
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [importStep, setImportStep] = useState(1); // 1=senha, 2=confirmar data, 3=digitar confirma, 4=sucesso
  const [importPassword, setImportPassword] = useState('');
  const [importPasswordError, setImportPasswordError] = useState('');
  const [importFile, setImportFile] = useState(null);
  const [importMetadata, setImportMetadata] = useState(null);
  const [importConfirmText, setImportConfirmText] = useState('');
  const [importingBackup, setImportingBackup] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const fileInputRef = useRef(null);
  // Google Drive (via rclone)
  const [gdriveStatus, setGdriveStatus] = useState(null);
  const [gdriveFiles, setGdriveFiles] = useState([]);
  const [gdriveUploading, setGdriveUploading] = useState(null);
  const [gdriveMessage, setGdriveMessage] = useState('');
  const [gdriveError, setGdriveError] = useState('');
  const [gdriveSetupOpen, setGdriveSetupOpen] = useState(false);
  const [gdriveRemote, setGdriveRemote] = useState('gdrive2');
  const [gdriveFolder, setGdriveFolder] = useState('Backups - Sistema Gestao');
  const [gdriveSettingUp, setGdriveSettingUp] = useState(false);
  const [gdriveRunning, setGdriveRunning] = useState(false);
  const [gdriveRunProgress, setGdriveRunProgress] = useState(null);
  const [gdriveFullRunning, setGdriveFullRunning] = useState(false);
  const [gdriveFullRunProgress, setGdriveFullRunProgress] = useState(null);
  const [gdriveApiRunning, setGdriveApiRunning] = useState(false);
  const [gdriveApiRunProgress, setGdriveApiRunProgress] = useState(null);
  // const isAuthenticated = useMemo(() => !!token, [token]);

  useEffect(() => {
    if (token) {
      const headers = { Authorization: `Bearer ${token}` };
      (async () => {
        // Verificar quais clientes o usuário tem acesso
        let clienteIds = null;
        try {
          const meResponse = await fetch(`${API}/me/clientes`, { headers });
          if (meResponse.ok) {
            const meData = await meResponse.json();
            clienteIds = meData.clientes || [];
          }
        } catch (e) {
          console.warn('Endpoint /me/clientes não disponível');
        }

        // Carregar todos os clientes
        try {
          const res = await fetch(`${API}/clientes`, { headers });
          if (res.ok) {
            let data = await res.json();
            // Filtrar se houver restrição
            if (clienteIds && clienteIds.length > 0) {
              data = data.filter(c => clienteIds.map(Number).includes(Number(c.id)));
            }
            setClientes(data);
          }
        } catch (err) {
          console.error(err);
        }
      })();
    }
  }, [token, API]);

  const fetchChamadosMetricas = useCallback(async () => {
    if (!token) return;
    try {
      const res = await fetch(`${API}/chamados/metricas`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        const abertos = (data.abertos || 0) + (data.em_andamento || 0);
        setChamadosAbertos(abertos);
      }
      setChamadosLoaded(true);
    } catch (e) {
      console.warn('Erro ao buscar métricas de chamados:', e);
      setChamadosLoaded(true);
    }
  }, [API, token]);

  const fetchEmergenciasPendentes = useCallback(async () => {
    if (!token) return;
    try {
      const res = await fetch(`${API}/chamados?tipo=emergencia`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        const untreated = (Array.isArray(data) ? data : []).filter((item) =>
          !['resolvido', 'fechado'].includes((item?.status || '').toString().toLowerCase())
        );
        setEmergenciasPendentes(untreated.length);
      }
    } catch (e) {
      console.warn('Erro ao buscar emergências pendentes:', e);
    }
  }, [API, token]);

  // Buscar métricas de chamados para o sino de notificação (refresh a cada 5s)
  useEffect(() => {
    if (!token) return;
    fetchChamadosMetricas();
    fetchEmergenciasPendentes();
    const intervalId = setInterval(() => {
      fetchChamadosMetricas();
      fetchEmergenciasPendentes();
    }, 5000);
    return () => clearInterval(intervalId);
  }, [token, fetchChamadosMetricas, fetchEmergenciasPendentes]);

  const resetOnlineCheckTimer = useCallback(() => {
    if (onlineCheckTimerRef.current) {
      clearTimeout(onlineCheckTimerRef.current);
      onlineCheckTimerRef.current = null;
    }

    if (!token || openOnlineCheckDialog) return;

    onlineCheckTimerRef.current = setTimeout(() => {
      setOpenOnlineCheckDialog(true);
    }, 15 * 60 * 1000);
  }, [token, openOnlineCheckDialog]);

  useEffect(() => {
    if (!token) return;

    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    const onActivity = () => {
      resetOnlineCheckTimer();
    };

    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true });
    });

    resetOnlineCheckTimer();

    return () => {
      activityEvents.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity);
      });
      if (onlineCheckTimerRef.current) {
        clearTimeout(onlineCheckTimerRef.current);
        onlineCheckTimerRef.current = null;
      }
    };
  }, [token, resetOnlineCheckTimer]);

  useEffect(() => {
    if (!token || !openOnlineCheckDialog) return;
    // Auto logout após 5 segundos se o diálogo foi aberto
    const autoLogoutTimer = setTimeout(() => {
      logout();
      navigate('/login');
    }, 5000);
    
    return () => clearTimeout(autoLogoutTimer);
  }, [openOnlineCheckDialog, token, logout, navigate]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
        const [resGer, resAr] = await Promise.all([
          fetch(`${API}/testes-loja/`, { headers: authHeaders }),
          fetch(`${API}/testes-ar-condicionados/`, { headers: authHeaders }),
        ]);
        const [dataGer, dataAr] = await Promise.all([
          resGer.ok ? resGer.json() : Promise.resolve([]),
          resAr.ok ? resAr.json() : Promise.resolve([]),
        ]);
        if (!mounted) return;
        const listGer = Array.isArray(dataGer) ? dataGer : [];
        const listAr = Array.isArray(dataAr) ? dataAr : [];
        const daysSince = (dateOrStr) => {
          if (!dateOrStr) return null;
          const d = new Date(dateOrStr);
          if (Number.isNaN(d.getTime())) return null;
          const diffMs = Date.now() - d.getTime();
          return Math.floor(diffMs / (1000 * 60 * 60 * 24));
        };
        const sameDay = (a, b) =>
          a.getFullYear() === b.getFullYear() &&
          a.getMonth() === b.getMonth() &&
          a.getDate() === b.getDate();
        const getLatestBy = (list, predicate) => {
          if (!Array.isArray(list)) return null;
          const candidates = list.filter(predicate);
          if (!candidates.length) return null;
          candidates.sort((a, b) => {
            return (
              new Date(b.data_teste || b.data || b.created_at || 0) -
              new Date(a.data_teste || a.data || a.created_at || 0)
            );
          });
          return candidates[0];
        };
        const today = new Date();
        const isThursday = today.getDay() === 4; // 0-dom, 4-qui
        let pendentes = 0;
        for (let i = 1; i <= 16; i++) {
          const ger = getLatestBy(listGer, (t) => Number(t.cliente_id) === i);
          const ar = getLatestBy(listAr, (t) => Number(t.cliente_id) === i);
          const gerDate = ger ? new Date(ger.data_teste || ger.data || ger.created_at) : null;
          const arDate = ar ? new Date(ar.data_teste || ar.data || ar.created_at) : null;
          const gerDays = gerDate ? daysSince(gerDate) : null;
          const arDays = arDate ? daysSince(arDate) : null;
          const gerOk = gerDays !== null && gerDays <= 7;
          const arOk = arDays !== null && arDays <= 7;
          const hasToday = [gerDate, arDate].some((d) => d && sameDay(d, today));
          const overdue = !(gerOk && arOk);
          const pendenteHoje = isThursday && !hasToday;
          if (overdue || pendenteHoje) pendentes++;
        }
        setHasPendentes(pendentes > 0);
      } catch (e) {
        if (!mounted) return;
        setTestesCount(0);
        // setTestesOffCount(0);
        // setTestesOkCount(0);
        setHasPendentes(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [API, token]);

  // Backup: carregar lista de backups
  const fetchBackupsList = useCallback(async () => {
    try {
      const res = await fetch(`${API}/backup/list`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (res.ok) {
        const data = await res.json();
        setBackups(Array.isArray(data.backups) ? data.backups : Array.isArray(data) ? data : []);
        setFullBackups(Array.isArray(data.full_backups) ? data.full_backups : []);
        setApiBackups(Array.isArray(data.api_backups) ? data.api_backups : []);
        if (data.full_progress) setFullBackupProgress(data.full_progress);
        if (data.api_progress) setApiProgress(data.api_progress);
      }
    } catch (e) {
      console.error('Erro ao carregar lista de backups:', e);
    }
  }, [API, token]);

  const fetchBackupStatus = useCallback(async () => {
    if (!isAdmin?.()) return;
    setLoadingBackup(true);
    try {
      const res = await fetch(`${API}/backup/status`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (res.ok) {
        const data = await res.json();
        setBackupStatus(data);
        setBackupError('');
      } else if (res.status === 401 || res.status === 403) {
        setBackupStatus(null);
        setBackupError('Você precisa estar logado como Administrador para executar backups.');
      }
    } catch (e) {
      // ignore
    } finally {
      setLoadingBackup(false);
    }
  }, [API, token, isAdmin]);

  // Criar novo backup
  const createBackup = async () => {
    setCreatingBackup(true);
    setBackupMessage('');
    setBackupError('');
    try {
      const res = await fetch(`${API}/backup/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setBackupMessage(`Backup criado: ${data.backup?.filename} (${data.backup?.size_human})`);
        await fetchBackupsList();
      } else {
        setBackupError(data.error || 'Erro ao criar backup');
      }
    } catch (e) {
      setBackupError('Erro de conexão ao criar backup');
    } finally {
      setCreatingBackup(false);
    }
  };

  // Download de backup com progresso
  const downloadBackup = async (backupId, filename) => {
    setDownloadingBackup(backupId);
    setDownloadProgress(0);
    setBackupError('');
    
    try {
      const res = await fetch(`${API}/backup/${backupId}/download`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      
      if (!res.ok) {
        throw new Error('Erro ao baixar backup');
      }
      
      const contentLength = res.headers.get('Content-Length');
      const total = contentLength ? parseInt(contentLength, 10) : 0;
      
      const reader = res.body.getReader();
      const chunks = [];
      let received = 0;
      
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        if (total > 0) {
          setDownloadProgress(Math.round((received / total) * 100));
        }
      }
      
      const blob = new Blob(chunks, { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || `${backupId}.zip`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      setDownloadProgress(100);
      setBackupMessage('Download concluído!');
    } catch (e) {
      setBackupError('Erro ao baixar backup: ' + e.message);
    } finally {
      setTimeout(() => {
        setDownloadingBackup(null);
        setDownloadProgress(0);
      }, 1500);
    }
  };

  // Excluir backup
  const deleteBackup = async (backupId) => {
    if (!window.confirm('Deseja realmente excluir este backup?')) return;
    try {
      const res = await fetch(`${API}/backup/${backupId}`, {
        method: 'DELETE',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (res.ok) {
        setBackupMessage('Backup excluído com sucesso');
        await fetchBackupsList();
      } else {
        const data = await res.json();
        setBackupError(data.error || 'Erro ao excluir backup');
      }
    } catch (e) {
      setBackupError('Erro de conexão ao excluir backup');
    }
  };

  // Criar backup completo (frontend + backend + database)
  const fullBackupPollingRef = React.useRef(null);

  const stopFullBackupPolling = () => {
    if (fullBackupPollingRef.current) {
      clearInterval(fullBackupPollingRef.current);
      fullBackupPollingRef.current = null;
    }
  };

  const startFullBackupPolling = () => {
    stopFullBackupPolling();
    fullBackupPollingRef.current = setInterval(async () => {
      try {
        const res = await fetch(`${API}/backup/full_progress`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) return;

        const progress = await res.json();
        setFullBackupProgress(progress);

        if (progress.status === 'running' || progress.status === 'pending') {
          const completed = Array.isArray(progress.completed_steps)
            ? progress.completed_steps.length
            : 0;
          setBackupError('');
          setBackupMessage(
            `${progress.current_step || 'Preparando backup completo'} (${completed}/${progress.total_steps || 7})`
          );
          return;
        }

        stopFullBackupPolling();
        setCreatingFullBackup(false);

        if (progress.status === 'completed') {
          setBackupError('');
          setBackupMessage(
            `Backup completo criado: ${progress.final_zip || progress.backup_id}.zip (${progress.final_size || 'tamanho indisponível'})`
          );
          fetchBackupsList();
          return;
        }

        if (progress.status === 'error') {
          setBackupMessage('');
          setBackupError(progress.error || 'Erro ao criar backup completo');
        }
      } catch {
        // Continuar tentando enquanto o backup estiver em andamento.
      }
    }, 3000);
  };

  const createFullBackup = async () => {
    setCreatingFullBackup(true);
    setBackupMessage('');
    setBackupError('');
    try {
      const res = await fetch(`${API}/backup/create_full`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });
      const data = await res.json();
      if (data.progress) setFullBackupProgress(data.progress);
      if (res.ok && data.success) {
        setBackupMessage(data.message || 'Backup completo iniciado em background');
        startFullBackupPolling();
        return;
      }

      if (!res.ok || !data.success) {
        setBackupError(data.error || 'Erro ao criar backup completo');
      }
    } catch (e) {
      setBackupError('Erro de conexão ao iniciar backup completo');
    } finally {
      if (!fullBackupPollingRef.current) {
        setCreatingFullBackup(false);
      }
    }
  };

  // Criar backup da API Diário de Obra (dispara em background + polling)
  const apiBackupPollingRef = React.useRef(null);

  const stopApiBackupPolling = () => {
    if (apiBackupPollingRef.current) {
      clearInterval(apiBackupPollingRef.current);
      apiBackupPollingRef.current = null;
    }
  };

  const startApiBackupPolling = () => {
    stopApiBackupPolling();
    apiBackupPollingRef.current = setInterval(async () => {
      try {
        const res = await fetch(`${API}/backup/api_progress`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (res.ok) {
          const progress = await res.json();
          setApiProgress(progress);

          // Atualizar mensagem de progresso
          const running = (progress.parts || []).filter(p => p.status === 'running');
          const completed = (progress.parts || []).filter(p => p.status === 'completed');
          if (running.length > 0) {
            setApiBackupCurrentPart(running[0].part);
            setBackupMessage(`Processando parte ${running[0].part}/${progress.total_parts || 5}... (${completed.length} concluída(s))`);
          } else {
            setApiBackupCurrentPart(completed.length);
          }

          // Verificar se terminou (status != running)
          if (progress.status && progress.status !== 'running' && progress.status !== 'pending') {
            stopApiBackupPolling();
            setCreatingApiBackup(false);
            setApiBackupCurrentPart(0);

            if (progress.status === 'completed') {
              setBackupMessage(`Backup da API concluído com sucesso (${progress.total_parts || 5}/${progress.total_parts || 5} partes)`);
              setBackupError('');
            } else if (progress.status === 'completed_with_errors') {
              const allErrors = (progress.global_errors || []);
              setBackupMessage(progress.summary || `Backup concluído com erros`);
              setBackupError(`Erros: ${allErrors.slice(0, 10).join(' | ')}${allErrors.length > 10 ? ` ... e mais ${allErrors.length - 10}` : ''}`);
            } else {
              setBackupError(progress.error || 'Erro no backup');
              setBackupMessage('');
            }
            fetchBackupsList();
          }
        }
      } catch {
        // Polling falhou — continuar tentando
      }
    }, 5000); // Poll a cada 5 segundos
  };

  const createApiBackup = async () => {
    const apiToken = localStorage.getItem('diariodeobra_token');
    if (!apiToken) {
      setBackupError('Token da API Diário de Obra não encontrado. Conecte-se primeiro na página de Integração.');
      return;
    }
    setCreatingApiBackup(true);
    setBackupMessage('Iniciando backup em background...');
    setBackupError('');
    setApiBackupCurrentPart(0);

    try {
      const res = await fetch(`${API}/backup/create_api`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ api_token: apiToken }),
      });
      const data = await res.json();
      if (data.progress) setApiProgress(data.progress);
      if (!res.ok || !data.success) {
        setBackupError(data.error || 'Erro ao iniciar backup');
        setCreatingApiBackup(false);
        return;
      }
      setBackupMessage('Backup em andamento... acompanhe o progresso abaixo.');
      // Iniciar polling de progresso
      startApiBackupPolling();
    } catch (e) {
      setBackupError('Erro de conexão ao iniciar backup');
      setCreatingApiBackup(false);
    }
  };

  // Limpar polling ao desmontar
  React.useEffect(() => {
    return () => {
      stopApiBackupPolling();
      stopFullBackupPolling();
    };
  }, []);

  // Ao abrir modal, verificar se há backup em andamento
  React.useEffect(() => {
    if (backupsModalOpen && fullBackupProgress?.status === 'running') {
      setCreatingFullBackup(true);
      setBackupMessage('Backup completo em andamento... acompanhe o progresso abaixo.');
      startFullBackupPolling();
    }

    if (backupsModalOpen && apiProgress?.status === 'running') {
      setCreatingApiBackup(true);
      setBackupMessage('Backup em andamento... acompanhe o progresso abaixo.');
      startApiBackupPolling();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backupsModalOpen, fullBackupProgress?.status]);

  // Abrir diálogo de importação
  const openImportDialog = () => {
    setImportStep(1);
    setImportPassword('');
    setImportPasswordError('');
    setImportFile(null);
    setImportMetadata(null);
    setImportConfirmText('');
    setImportResult(null);
    setImportDialogOpen(true);
  };

  // Fechar diálogo de importação
  const closeImportDialog = () => {
    setImportDialogOpen(false);
    setImportStep(1);
    setImportPassword('');
    setImportPasswordError('');
    setImportFile(null);
    setImportMetadata(null);
    setImportConfirmText('');
    setImportResult(null);
  };

  // Selecionar arquivo de backup
  const handleFileSelect = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    
    setImportFile(file);
    setImportPasswordError('');
    
    // Validar arquivo de backup
    const formData = new FormData();
    formData.append('file', file);
    
    try {
      const res = await fetch(`${API}/backup/validate_restore`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setImportMetadata(data);
      } else {
        setImportPasswordError(data.error || 'Arquivo de backup inválido');
        setImportFile(null);
      }
    } catch (e) {
      setImportPasswordError('Erro ao validar arquivo de backup');
      setImportFile(null);
    }
  };

  // Validar senha e avançar para próximo passo
  const validatePasswordAndProceed = async () => {
    if (!importPassword.trim()) {
      setImportPasswordError('Digite a senha de administrador');
      return;
    }
    
    // A validação real da senha será feita no momento da restauração
    // Aqui apenas avançamos para o próximo passo
    setImportStep(2);
    setImportPasswordError('');
  };

  // Executar restauração do backup
  const executeRestore = async () => {
    if (!importFile) return;
    
    setImportingBackup(true);
    setImportPasswordError('');
    
    const formData = new FormData();
    formData.append('file', importFile);
    formData.append('password', importPassword);
    
    try {
      const res = await fetch(`${API}/backup/restore`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
      });
      const data = await res.json();
      
      if (res.ok && data.success) {
        setImportResult(data);
        setImportStep(4);
      } else {
        if (res.status === 401) {
          setImportStep(1);
          setImportPasswordError(data.error || 'Senha de administrador incorreta');
        } else {
          setImportPasswordError(data.error || 'Erro ao restaurar backup');
        }
      }
    } catch (e) {
      setImportPasswordError('Erro de conexão ao restaurar backup');
    } finally {
      setImportingBackup(false);
    }
  };

  useEffect(() => {
    fetchBackupStatus();
  }, [fetchBackupStatus, token]);

  // Carregar lista de backups quando o modal abrir
  useEffect(() => {
    if (backupsModalOpen) {
      fetchBackupsList();
    }
  }, [backupsModalOpen, fetchBackupsList]);

  // Ações diretas de backup removidas (uso via modal/diálogo)

  // === Google Drive ===
  const fetchGdriveStatus = useCallback(async () => {
    if (!token) return;
    try {
      const res = await fetch(`${API}/backup/gdrive/status`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) {
        const data = await res.json();
        setGdriveStatus(data);
        if (data.configured) {
          const r2 = await fetch(`${API}/backup/gdrive/files`, { headers: { Authorization: `Bearer ${token}` } });
          if (r2.ok) setGdriveFiles((await r2.json()).files || []);
        }
      }
      // Sync run progress state with server on modal open
      const rp = await fetch(`${API}/backup/gdrive/run/progress`, { headers: { Authorization: `Bearer ${token}` } });
      if (rp.ok) {
        const p = await rp.json();
        if (p.status === 'done' || p.status === 'idle' || p.status === 'error') {
          setGdriveRunning(false);
          setGdriveRunProgress(null);
        } else if (p.status === 'uploading' || p.status === 'creating') {
          // Resume polling for in-progress backup
          setGdriveRunning(true);
          setGdriveRunProgress(p);
          const poll = setInterval(async () => {
            try {
              const pr = await fetch(`${API}/backup/gdrive/run/progress`, { headers: { Authorization: `Bearer ${token}` } });
              if (!pr.ok) return;
              const pp = await pr.json();
              setGdriveRunProgress(pp);
              if (pp.status === 'done') {
                clearInterval(poll);
                setGdriveRunning(false);
                setGdriveMessage(`✓ Backup enviado ao Drive: ${pp.file || ''}`);
              } else if (pp.status === 'error' || pp.status === 'idle') {
                clearInterval(poll);
                setGdriveRunning(false);
                if (pp.status === 'error') setGdriveError(pp.message || 'Erro no backup');
              }
            } catch (_) {}
          }, 3000);
        }
      }
      const rfp = await fetch(`${API}/backup/gdrive/run_full/progress`, { headers: { Authorization: `Bearer ${token}` } });
      if (rfp.ok) {
        const p = await rfp.json();
        if (p.status === 'done' || p.status === 'idle' || p.status === 'error') {
          setGdriveFullRunning(false);
          setGdriveFullRunProgress(p.status === 'error' ? p : null);
        } else if (p.status === 'uploading' || p.status === 'creating') {
          setGdriveFullRunning(true);
          setGdriveFullRunProgress(p);
          const poll = setInterval(async () => {
            try {
              const pr = await fetch(`${API}/backup/gdrive/run_full/progress`, { headers: { Authorization: `Bearer ${token}` } });
              if (!pr.ok) return;
              const pp = await pr.json();
              setGdriveFullRunProgress(pp);
              if (pp.status === 'done') {
                clearInterval(poll);
                setGdriveFullRunning(false);
                setGdriveMessage(`✓ Backup completo enviado ao Drive: ${pp.file || ''}`);
                await fetchGdriveStatus();
              } else if (pp.status === 'error' || pp.status === 'idle') {
                clearInterval(poll);
                setGdriveFullRunning(false);
                if (pp.status === 'error') setGdriveError(pp.message || 'Erro no backup completo');
              }
            } catch (_) {}
          }, 2000);
        }
      }
      const rap = await fetch(`${API}/backup/gdrive/run_api/progress`, { headers: { Authorization: `Bearer ${token}` } });
      if (rap.ok) {
        const p = await rap.json();
        if (p.status === 'done' || p.status === 'idle' || p.status === 'error') {
          setGdriveApiRunning(false);
          setGdriveApiRunProgress(p.status === 'error' ? p : null);
        } else if (p.status === 'downloading' || p.status === 'uploading') {
          setGdriveApiRunning(true);
          setGdriveApiRunProgress(p);
          _startGdriveApiPolling();
        }
      }
    } catch (_) {}
  }, [token]);

  useEffect(() => {
    if (backupsModalOpen) fetchGdriveStatus();
  }, [backupsModalOpen, fetchGdriveStatus]);

  const gdriveSetup = async () => {
    setGdriveSettingUp(true);
    setGdriveError('');
    try {
      const form = new FormData();
      form.append('remote', gdriveRemote.trim() || 'gdrive');
      form.append('folder', gdriveFolder.trim() || 'Backups - Sistema Gestão');
      const res = await fetch(`${API}/backup/gdrive/save_config`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        setGdriveSetupOpen(false);
        setGdriveMessage('Google Drive configurado com sucesso!');
        await fetchGdriveStatus();
      } else {
        setGdriveError(data.detail || 'Erro ao configurar Google Drive');
      }
    } catch (e) {
      setGdriveError('Erro de conexão: ' + e.message);
    } finally {
      setGdriveSettingUp(false);
    }
  };

  const gdriveUpload = async (filename) => {
    setGdriveUploading(filename);
    setGdriveMessage('');
    setGdriveError('');
    try {
      const res = await fetch(`${API}/backup/gdrive/upload/${encodeURIComponent(filename)}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        setGdriveMessage(`Enviado: ${data.name}`);
        await fetchGdriveStatus();
      } else {
        setGdriveError(data.detail || 'Erro ao enviar para o Drive');
      }
    } catch (e) {
      setGdriveError('Erro de conexão: ' + e.message);
    } finally {
      setGdriveUploading(null);
    }
  };

  const gdriveUploadLatest = async () => {
    const all = [...backups, ...fullBackups, ...apiBackups];
    if (!all.length) { setGdriveError('Nenhum backup disponível'); return; }
    all.sort((a, b) => (b.created_at || b.CreatedAt || '').localeCompare(a.created_at || a.CreatedAt || ''));
    await gdriveUpload(all[0].filename || all[0].name || all[0].Name);
  };

  const createGdriveBackup = async () => {
    setGdriveRunning(true);
    setGdriveMessage('');
    setGdriveError('');
    setGdriveRunProgress({ status: 'creating', percent: 0, message: 'Iniciando...' });
    try {
      const res = await fetch(`${API}/backup/gdrive/run`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!res.ok) {
        setGdriveError(data.detail || 'Erro ao iniciar backup');
        setGdriveRunning(false);
        setGdriveRunProgress(null);
        return;
      }
      // Polling de progresso
      const poll = setInterval(async () => {
        try {
          const pr = await fetch(`${API}/backup/gdrive/run/progress`, { headers: { Authorization: `Bearer ${token}` } });
          if (!pr.ok) return;
          const p = await pr.json();
          setGdriveRunProgress(p);
          if (p.status === 'done') {
            clearInterval(poll);
            setGdriveRunning(false);
            setGdriveMessage(`✓ Backup enviado ao Drive: ${p.file || ''}`);
            await fetchGdriveStatus();
            await fetchBackupsList();
          } else if (p.status === 'error') {
            clearInterval(poll);
            setGdriveRunning(false);
            setGdriveError(p.message || 'Erro no backup');
            setGdriveRunProgress(null);
          }
        } catch (_) {}
      }, 2000);
    } catch (e) {
      setGdriveError('Erro de conexão: ' + e.message);
      setGdriveRunning(false);
      setGdriveRunProgress(null);
    }
  };

  const _startFullBackupPolling = () => {
    const poll = setInterval(async () => {
      try {
        const pr = await fetch(`${API}/backup/gdrive/run_full/progress`, { headers: { Authorization: `Bearer ${token}` } });
        if (!pr.ok) return;
        const p = await pr.json();
        setGdriveFullRunProgress(p);
        if (p.status === 'done') {
          clearInterval(poll);
          setGdriveFullRunning(false);
          setGdriveMessage(`✓ Backup completo enviado ao Drive: ${p.file || ''}`);
          await fetchGdriveStatus();
        } else if (p.status === 'error' || p.status === 'idle') {
          clearInterval(poll);
          setGdriveFullRunning(false);
          if (p.status === 'error') setGdriveError(p.message || 'Erro no backup completo');
        }
      } catch (_) {}
    }, 2000);
  };

  const createGdriveFullBackup = async (force = false) => {
    if (gdriveFullRunning) {
      setGdriveError('');
      setGdriveMessage('⚠ Backup completo já está em andamento. Aguarde a conclusão.');
      return;
    }
    setGdriveFullRunning(true);
    setGdriveFullRunProgress({ status: 'creating', percent: 0, message: force ? 'Reiniciando do zero...' : 'Iniciando...' });
    setGdriveError('');
    try {
      const url = `${API}/backup/gdrive/run_full${force ? '?force=true' : ''}`;
      const res = await fetch(url, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (!res.ok) {
        if (res.status === 409) {
          // já rodando em background — apenas sincroniza o estado e começa a polear
          setGdriveFullRunProgress({ status: 'creating', percent: 0, message: 'Backup já em andamento em segundo plano...' });
          _startFullBackupPolling();
          return;
        }
        setGdriveError(data.detail || 'Erro ao iniciar backup completo');
        setGdriveFullRunning(false);
        setGdriveFullRunProgress(null);
        return;
      }
      _startFullBackupPolling();
    } catch (e) {
      setGdriveError('Erro de conexão: ' + e.message);
      setGdriveFullRunning(false);
      setGdriveFullRunProgress(null);
    }
  };

  const _startGdriveApiPolling = () => {
    const poll = setInterval(async () => {
      try {
        const pr = await fetch(`${API}/backup/gdrive/run_api/progress`, { headers: { Authorization: `Bearer ${token}` } });
        if (!pr.ok) return;
        const p = await pr.json();
        setGdriveApiRunProgress(p);
        if (p.status === 'done') {
          clearInterval(poll);
          setGdriveApiRunning(false);
          setGdriveMessage(`✓ Backup API enviado ao Drive: ${p.file || ''}`);
          await fetchGdriveStatus();
        } else if (p.status === 'error' || p.status === 'idle') {
          clearInterval(poll);
          setGdriveApiRunning(false);
          if (p.status === 'error') setGdriveError(p.message || 'Erro no backup API');
        }
      } catch (_) {}
    }, 2000);
  };

  const createGdriveApiBackup = async () => {
    if (gdriveApiRunning) {
      setGdriveError('');
      setGdriveMessage('⚠ Backup API já está em andamento. Aguarde a conclusão.');
      return;
    }
    const apiToken = localStorage.getItem('diariodeobra_token');
    if (!apiToken) {
      setGdriveError('Token da API Diário de Obra não encontrado. Conecte-se primeiro.');
      return;
    }
    setGdriveApiRunning(true);
    setGdriveApiRunProgress({ status: 'downloading', percent: 0, message: 'Iniciando...' });
    setGdriveError('');
    try {
      const res = await fetch(`${API}/backup/gdrive/run_api`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ api_token: apiToken }),
      });
      const data = await res.json();
      if (!res.ok) {
        if (res.status === 409) {
          setGdriveApiRunProgress({ status: 'downloading', percent: 0, message: 'Backup já em andamento em segundo plano...' });
          _startGdriveApiPolling();
          return;
        }
        setGdriveError(data.detail || 'Erro ao iniciar backup API');
        setGdriveApiRunning(false);
        setGdriveApiRunProgress(null);
        return;
      }
      _startGdriveApiPolling();
    } catch (e) {
      setGdriveError('Erro de conexão: ' + e.message);
      setGdriveApiRunning(false);
      setGdriveApiRunProgress(null);
    }
  };

  const gdriveDisconnect = async () => {
    if (!window.confirm('Deseja remover a conexão com o Google Drive?')) return;
    try {
      await fetch(`${API}/backup/gdrive/disconnect`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      setGdriveStatus({ configured: false });
      setGdriveFiles([]);
      setGdriveMessage('');
    } catch (_) {}
  };

  const toggleFile = (id) => {
    setSelectedFiles((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const allDashboardCards = [
    {
      title: 'Contratos',
      description: 'Gerenciar contratos e obras',
      icon: Construction,
      color: theme.palette.primary.main,
      path: '/contratos',
      permission: '/contratos',
    },
    {
      title: 'Relatório de Obras',
      description: 'Inspeção e relatórios de obras',
      icon: Assessment,
      color: theme.palette.info.main,
      path: '/relatorio-obras',
      permission: '/relatorio-obras',
      banvaleHidden: true,
    },
    {
      title: 'Consulta Relatório de Obras',
      description: 'Pesquisar e visualizar RDOs',
      icon: Search,
      color: '#42A5F5',
      path: '/relatorios-consulta',
      permission: '/relatorios-consulta',
      banvaleHidden: true,
    },
    {
      title: 'Abrir Chamado',
      description: 'Abrir novo chamado de suporte',
      icon: SupportAgent,
      color: '#00897b',
      path: '/chamados/novo',
      permission: '/chamados',
      banvaleHidden: true,
    },
    {
      title: 'Emergência',
      description: 'Abrir chamado emergencial com prioridade máxima',
      icon: ReportProblem,
      color: '#b71c1c',
      path: '/chamados/novo',
      permission: '/chamados',
    },
    {
      title: 'Consultar Chamados',
      description: 'Pesquisar e acompanhar chamados',
      icon: SupportAgent,
      color: '#26a69a',
      path: '/chamados-consulta',
      permission: '/chamados',
      banvaleHidden: true,
    },
    {
      title: 'Clientes',
      description: 'Cadastro e gestão de clientes',
      icon: People,
      color: theme.palette.secondary.main,
      path: '/clientes',
      permission: '/clientes',
    },
    {
      title: 'Financeiro',
      description: 'Controle financeiro e despesas',
      icon: AttachMoney,
      color: theme.palette.warning.main,
      path: '/financeiro',
      permission: '/financeiro',
      adminOnly: true,
    },
    {
      title: 'Testes de Loja',
      description: 'Agendamentos e registros de testes',
      icon: Storefront,
      color: theme.palette.primary.light,
      path: '/testes-loja-menu',
      permission: '/testes-loja-menu',
      banvaleHidden: true,
    },
    {
      title: 'Estrutura',
      description: 'Gestão de Obra e Segurança',
      icon: Construction,
      color: '#8e44ad',
      path: '/estrutura',
      permission: '/estrutura',
      banvaleHidden: true,
    },
    {
      title: 'Consultar OS / NFE',
      description: 'Consulta de OS e NFE com filtros e ocorrências',
      icon: ReceiptLong,
      color: '#16a085',
      path: '/recebimento-os/consulta',
      permission: '/recebimento-os',
    },
    {
      title: 'RECEBER OS / NFE',
      description: 'Recebimento de OS e NFE',
      icon: ReceiptLong,
      color: '#2ecc71',
      path: '/recebimento-os',
      permission: '/recebimento-os',
      willianOnly: true,
    },
    {
      title: 'Agenda',
      description: 'Calendários e assinaturas',
      icon: CalendarMonth,
      color: '#0288d1',
      path: '/agenda',
      permission: '/',
      banvaleHidden: true,
    },
    {
      title: 'Fluxo Cronograma',
      description: 'Kanban de andamento da obra',
      icon: ViewColumn,
      color: '#1a237e',
      path: '/fluxo-cronograma',
      permission: '/',
    },
    {
      title: 'Agente',
      description: 'Integração WhatsApp e monitoramento',
      icon: SmartToy,
      color: '#25d366',
      path: '/agente',
      permission: '/agente',
      openInNewTab: true,
    },
    {
      title: 'Log de Acesso',
      description: 'Histórico de acessos ao sistema',
      icon: HistoryIcon,
      color: '#9c27b0',
      path: '/access-log',
      permission: '/admin',
      adminOnly: true,
      banvaleHidden: true,
    },
    {
      title: 'Admin',
      description: 'Administração do sistema',
      icon: ExitToApp,
      color: theme.palette.grey[600],
      path: '/cadastro-usuarios',
      permission: '/admin',
      adminOnly: true,
    },
    {
      title: 'Equipamentos',
      description: 'Gestão de equipamentos por cliente',
      icon: DevicesIcon,
      color: '#00838f',
      path: '/equipamentos',
      permission: '/equipamentos',
    },
  ];

  // Parseia cards_permitidos do usuário (pode ser string JSON ou array)
  const userCardsPermitidos = React.useMemo(() => {
    if (!user?.cards_permitidos) return null;
    try {
      const parsed = typeof user.cards_permitidos === 'string'
        ? JSON.parse(user.cards_permitidos)
        : user.cards_permitidos;
      return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch {
      return null;
    }
  }, [user?.cards_permitidos]);

  const isWillians = user?.username?.toLowerCase() === 'willians';

  const isBanvale = process.env.REACT_APP_SITE === 'banvale';

  const filteredCards = allDashboardCards.filter((card) => {
    // Cards ocultos no site banvale
    if (isBanvale && card.banvaleHidden) return false;

    // Cards exclusivos do Willians
    if (card.willianOnly && !isWillians) return false;

    // Admin: acesso total (ignora cards_permitidos)
    if (isAdmin()) {
      return true;
    }

    // Se o admin configurou cards específicos para este usuário, usa essa lista
    if (userCardsPermitidos) {
      return userCardsPermitidos.includes(card.title);
    }

    // Gestor: tudo EXCETO "Log de Acesso" e "Admin"
    if (isGestor()) {
      if (card.title === 'Log de Acesso' || card.title === 'Admin') return false;
      return true;
    }

    // Supervisor e Técnico: cards específicos
    if (isSupervisor() || isTecnico()) {
      const allowedCards = [
        'Consulta Relatório de Obras',
        'RECEBER OS / NFE',
        'Consultar OS / NFE',
        'Consultar Chamados',
        'Abrir Chamado',
        'Emergência',
        'Agenda',
      ];
      return allowedCards.includes(card.title);
    }

    // Cliente: apenas chamados
    if (isCliente()) {
      const allowedCards = ['Abrir Chamado', 'Emergência', 'Consultar Chamados', 'Agenda'];
      return allowedCards.includes(card.title);
    }

    // Manutenção: não pode abrir chamados, apenas consultar
    if (isManutencao()) {
      if (card.title === 'Abrir Chamado') return false;
      if (card.title === 'Emergência') return false;
      if (card.adminOnly) return false;
      return hasPermission(card.permission);
    }

    // Outros roles: usa hasPermission
    if (card.adminOnly) return false;
    return hasPermission(card.permission);
  });

  // Forçar ordem desejada: Obras acima de Clientes
  const desiredOrder = [
    'Obras',
    'Relatório de Obras',
    'Consulta Relatório de Obras',
    'Emergência',
    'Clientes',
    'Financeiro',
    'Testes de Loja',
    'Estrutura',
    'Consultar OS / NFE',
    'RECEBER OS / NFE',
    'Agenda',
    'Fluxo Cronograma',
    'Agente',
    'Log de Acesso',
    'Admin',
    'Equipamentos',
  ];
  const sortedCards = [...filteredCards].sort((a, b) => {
    const ia = desiredOrder.indexOf(a.title);
    const ib = desiredOrder.indexOf(b.title);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  });

  const prewarmAgent = useCallback(
    ({ force = false } = {}) => {
      if (!token || !hasPermission('/agente')) return;
      if (agentWarmupRef.current && !force) return;
      agentWarmupRef.current = true;

      import('./Agente').catch(() => {});

      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const warmFetch = (path) => {
        const controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 6000);
        return fetch(`${API}${path}`, {
          headers,
          signal: controller.signal,
          cache: 'no-store',
        })
          .catch(() => null)
          .finally(() => window.clearTimeout(timer));
      };

      Promise.allSettled([
        warmFetch('/whatsapp-messages?limit=10'),
        warmFetch('/whatsapp-messages/stats'),
        warmFetch('/whatsapp-connections'),
        warmFetch('/whatsapp-connections/health'),
      ]).catch(() => {});
    },
    [API, hasPermission, token]
  );

  useEffect(() => {
    if (!token || !hasPermission('/agente')) return undefined;

    const warmupTimer = window.setTimeout(() => prewarmAgent(), 1200);
    const keepWarmInterval = window.setInterval(() => prewarmAgent({ force: true }), 45000);

    return () => {
      window.clearTimeout(warmupTimer);
      window.clearInterval(keepWarmInterval);
    };
  }, [hasPermission, prewarmAgent, token]);

  const handleCardClick = (path, title, openInNewTab = false) => {
    console.log('=== CARD CLICK DEBUG ===');
    console.log('Title:', title);
    console.log('Path:', path);
    console.log('Navigate function:', typeof navigate);
    
    if (title === 'Testes de Loja') {
      console.log('Opening Testes Modal');
      setOpenTestesModal(true);
      return;
    }
    
    if (title === 'Consulta Relatório de Obras') {
      console.log('Opening Consulta Relatórios Modal');
      setOpenConsultaRelatoriosModal(true);
      return;
    }

    if (title === 'Consultar Chamados') {
      console.log('Opening Consulta Chamados Modal');
      setOpenConsultaChamadosModal(true);
      return;
    }

    if (title === 'Abrir Chamado') {
      console.log('Opening Abrir Chamado Modal');
      setAbrirChamadoPrefill(null);
      setIsEmergencyFlow(false);
      setOpenAbrirChamadoModal(true);
      return;
    }

    if (title === 'Emergência') {
      console.log('Opening Emergência Chamado Modal');
      const nowIso = new Date().toISOString();
      setAbrirChamadoPrefill({
        titulo: 'Emergência',
        descricao: '',
        tipo: 'emergencia',
        prioridade: 'urgente',
        prazoConclusao: nowIso.split('T')[0],
        observacoes: `Abertura de emergência em ${formatDateTimeBr(nowIso)}`,
        emergencyMode: true,
      });
      setIsEmergencyFlow(true);
      setOpenAbrirChamadoModal(true);
      return;
    }

    if (title === 'Estrutura') {
      console.log('Opening Estrutura Dialog');
      // Remove focus from the card to prevent "Blocked aria-hidden" warning
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      setOpenEstruturaDialog(true);
      return;
    }

    if (title === 'RECEBER OS / NFE') {
      setOpenRecebimentoModal(true);
      return;
    }

    if (title === 'Consultar OS / NFE') {
      setOpenConsultaRecebimentoModal(true);
      return;
    }

    if (title === 'Agenda') {
      setOpenAgendaModal(true);
      return;
    }

    if (title === 'Fluxo Cronograma') {
      setOpenFluxoCronogramaModal(true);
      return;
    }

    if (title === 'Log de Acesso') {
      console.log('Opening Access Log Modal');
      setOpenAccessLogModal(true);
      return;
    }
    
    try {
      if (openInNewTab) {
        if (title === 'Agente') {
          prewarmAgent({ force: true });
        }

        const targetUrl = new URL(path, window.location.origin).toString();
        const newWindow = window.open(targetUrl, '_blank', 'noopener,noreferrer');

        if (newWindow) {
          newWindow.opener = null;
          console.log('Opened in new tab:', targetUrl);
        }

        return;
      }

      console.log('Attempting navigate to:', path);
      navigate(path);
      console.log('Navigate successful');
    } catch (e) {
      console.error('Navigate error:', e);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', p: 3 }}>
      <Box sx={{ maxWidth: 940, mx: 'auto', background: 'white', borderRadius: 3, p: 4 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            mb: 4,
            gap: 2,
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              Dashboard
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Bem-vindo, {user?.nome}!
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              alignItems: 'center',
              flexWrap: 'wrap',
              width: { xs: '100%', sm: 'auto' },
              justifyContent: { xs: 'space-between', sm: 'flex-end' },
            }}
          >
            <ApiStatusBadge />
            <Tooltip title="Limpar Cache/Reload">
              <IconButton size="small" onClick={clearCache} sx={{ border: '1px solid #ccc' }}>
                <CachedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Button variant="outlined" color="error" onClick={logout} size="small">
              Sair
            </Button>
          </Box>
        </Box>

        <Grid container spacing={{ xs: 2, sm: 3 }} alignItems="stretch" justifyContent="center">
          {sortedCards.map((card, index) => {
            const isEmergencyCard = card.title === 'Emergência';
            const shouldBlinkEmergency = isEmergencyCard && emergenciasPendentes > 0;
            return (
              <Grid item xs={'auto'} sm={'auto'} md={'auto'} key={index}>
                <Card
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardClick(card.path, card.title, card.openInNewTab)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleCardClick(card.path, card.title, card.openInNewTab);
                    }
                  }}
                  sx={{
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    borderRadius: 4,
                    boxShadow: '0 16px 40px rgba(0,0,0,0.12)',
                    backgroundColor: isEmergencyCard ? '#b71c1c' : '#fff',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 24px 60px rgba(0,0,0,0.16)',
                    },
                    ...(shouldBlinkEmergency
                      ? {
                          animation: 'emergencyPulse 0.9s ease-in-out infinite alternate',
                          '@keyframes emergencyPulse': {
                            '0%': { boxShadow: '0 0 0 0 rgba(255, 235, 59, 0.4)' },
                            '100%': { boxShadow: '0 0 0 12px rgba(255, 235, 59, 0)' },
                          },
                        }
                      : {}),
                    width: 150,
                    height: CARD_HEIGHT,
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardContent
                    sx={{
                      p: 0, // sem padding para aproveitar totalmente os 150x150
                      pt: '10px', // padding superior solicitado para afastar o avatar do topo
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexGrow: 1,
                      width: '100%',
                      gap: 0,
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 60,
                        height: 60,
                        mb: '10px', // reduzido para dar espaço ao título
                        bgcolor: card.color,
                        alignSelf: 'center',
                      }}
                    >
                      <card.icon sx={{ fontSize: 32, color: 'white' }} />
                    </Avatar>
                    <Typography component="div" sx={{ ...getTitleSx(card.title), px: 1, color: isEmergencyCard ? '#ffeb3b' : 'inherit' }}>
                      {card.title}
                    </Typography>
                    {/* Área de ação padronizada: reserva espaço fixo para o botão */}
                    <Box
                      sx={{
                        height: ACTION_AREA_HEIGHT,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 0.25,
                        px: 1,
                      }}
                    >
                      {card.title === 'Testes de Loja' ? (
                        <Button
                          size="small"
                          variant="contained"
                          color={hasPendentes ? 'error' : 'success'}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenPendentes(hasPendentes);
                            setOpenTestesModal(true);
                          }}
                          sx={{
                            fontSize: '0.60rem', // reduz fonte
                            lineHeight: 1.1,
                            px: 0.6, // padding horizontal reduzido
                            py: 0.25, // padding vertical menor
                            minHeight: 16, // cerca de 1/3 menor que ~24 padrão
                            minWidth: 60, // largura enxuta
                            borderRadius: 1.2,
                            fontWeight: 700,
                            letterSpacing: 0.3,
                            '& .MuiButton-startIcon,& .MuiButton-endIcon': { m: 0 },
                          }}
                        >
                          {hasPendentes ? 'PENDÊNCIAS' : 'LOJAS OK'}
                        </Button>
                      ) : card.title === 'Consultar Chamados' ? (
                        <Tooltip title={chamadosLoaded ? (chamadosAbertos > 0 ? `${chamadosAbertos} chamado(s) aberto(s)` : 'Nenhum chamado aberto') : 'Carregando...'}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenConsultaChamadosModal(true);
                            }}
                          >
                            <NotificationsIcon
                              sx={{
                                fontSize: 22,
                                color: chamadosAbertos > 0 ? '#d32f2f' : '#2e7d32',
                                animation: chamadosAbertos > 0 ? 'bellShake 0.5s ease-in-out infinite alternate' : 'none',
                                '@keyframes bellShake': {
                                  '0%': { transform: 'rotate(-8deg)' },
                                  '100%': { transform: 'rotate(8deg)' },
                                },
                              }}
                            />
                            {chamadosAbertos > 0 && (
                              <Typography
                                component="span"
                                sx={{
                                  fontSize: '0.6rem',
                                  fontWeight: 700,
                                  color: '#d32f2f',
                                  ml: 0.3,
                                }}
                              >
                                {chamadosAbertos}
                              </Typography>
                            )}
                          </Box>
                        </Tooltip>
                      ) : card.title === 'Abrir Chamado' ? (
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenAbrirChamadoModal(true);
                          }}
                          sx={{
                            fontSize: '0.60rem',
                            lineHeight: 1.1,
                            px: 0.6,
                            py: 0.25,
                            minHeight: 16,
                            minWidth: 60,
                            borderRadius: 1.2,
                            fontWeight: 700,
                            letterSpacing: 0.3,
                          }}
                        >
                          NOVO
                        </Button>
                      ) : card.title === 'Emergência' ? (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCardClick(card.path, card.title, card.openInNewTab);
                          }}
                          sx={{
                            fontSize: '0.60rem',
                            lineHeight: 1.1,
                            px: 0.6,
                            py: 0.25,
                            minHeight: 16,
                            minWidth: 60,
                            borderRadius: 1.2,
                            fontWeight: 800,
                            letterSpacing: 0.3,
                            backgroundColor: '#ffeb3b',
                            color: '#8e0000',
                            '&:hover': {
                              backgroundColor: '#fdd835',
                            },
                          }}
                        >
                          {emergenciasPendentes > 0 ? `${emergenciasPendentes} PEND.` : 'ABRIR'}
                        </Button>
                      ) : card.title === 'Admin' ? (
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            // abrir modal de backups
                            setBackupsModalOpen(true);
                          }}
                          sx={{
                            fontSize: '0.60rem',
                            lineHeight: 1.1,
                            px: 0.6,
                            py: 0.25,
                            minHeight: 16,
                            minWidth: 60,
                            borderRadius: 1.2,
                            fontWeight: 700,
                            letterSpacing: 0.3,
                          }}
                        >
                          BACKUP
                        </Button>
                      ) : (
                        // Placeholder invisível para manter a mesma altura
                        <Box sx={{ height: ACTION_AREA_HEIGHT }} />
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        {/* Integração com API Externa Diário de Obra */}
        {!isBanvale && (isAdmin() || user?.agenda_diario_obra) && <DiarioDeObraIntegration />}

        <Box
          sx={{
            textAlign: 'center',
            mt: 6,
            pt: 3,
            borderTop: '1px solid',
            borderColor: theme.palette.grey[200],
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {isBanvale ? 'ERP Banvale' : 'Sistema de Gestão de Obras'} © {new Date().getFullYear()}
          </Typography>
        </Box>
      </Box>

      <TestesModal
        open={openTestesModal}
        onClose={() => {
          setOpenTestesModal(false);
          setOpenPendentes(false);
        }}
        API={API}
        navigate={navigate}
        initialPendentes={openPendentes}
      />

      <Dialog
        open={backupsModalOpen}
        onClose={() => setBackupsModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>Gerenciar Backups (até 15 dias)</span>
            <Tooltip title="Atualizar lista">
              <IconButton onClick={fetchBackupsList} size="small">
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </DialogTitle>
        <DialogContent>
          {/* Barra de progresso de download */}
          {downloadingBackup && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="primary" sx={{ mb: 1 }}>
                Baixando backup... {downloadProgress}%
              </Typography>
              <LinearProgress 
                variant="determinate" 
                value={downloadProgress} 
                sx={{ height: 10, borderRadius: 5 }}
              />
            </Box>
          )}
          
          {/* Mensagens */}
          {backupMessage && (
            <Typography variant="body2" color="success.main" sx={{ mb: 2 }}>
              ✓ {backupMessage}
            </Typography>
          )}
          {backupError && (
            <Typography variant="body2" color="error" sx={{ mb: 2 }}>
              ✗ {backupError}
            </Typography>
          )}
          
          {/* Botões de criar backup */}
          <Box sx={{ mb: 2, display: 'flex', gap: 1, flexDirection: 'column' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={createBackup}
              disabled={creatingBackup || creatingFullBackup || gdriveRunning}
              startIcon={creatingBackup ? <CircularProgress size={16} color="inherit" /> : <CloudDownloadIcon />}
              fullWidth
            >
              {creatingBackup ? 'Criando backup...' : 'Criar Backup (DB + Uploads)'}
            </Button>

            {/* Botão Google Drive direto */}
            {gdriveStatus?.configured && (
              <Button
                variant="contained"
                fullWidth
                sx={{ bgcolor: '#1a73e8', '&:hover': { bgcolor: '#1558b0' }, fontWeight: 'bold' }}
                onClick={createGdriveBackup}
                disabled={gdriveRunning || creatingBackup || creatingFullBackup}
                startIcon={gdriveRunning ? <CircularProgress size={16} color="inherit" /> : <GDriveIcon />}
              >
                {gdriveRunning
                  ? (gdriveRunProgress?.message || 'Processando...')
                  : 'Backup DB + Uploads → Google Drive'}
              </Button>
            )}
            {gdriveRunning && gdriveRunProgress && (
              <Box sx={{ px: 0.5 }}>
                <LinearProgress
                  variant="determinate"
                  value={gdriveRunProgress.percent || 0}
                  sx={{ height: 5, borderRadius: 3, bgcolor: '#e3f2fd', '& .MuiLinearProgress-bar': { bgcolor: '#1a73e8' } }}
                />
                <Typography variant="caption" color="text.secondary">
                  {gdriveRunProgress.status === 'creating' ? 'Criando backup...' : 'Enviando ao Drive...'} {Math.round(gdriveRunProgress.percent || 0)}%
                </Typography>
              </Box>
            )}

            {gdriveStatus?.configured && (
              <>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ bgcolor: '#1a73e8', '&:hover': { bgcolor: '#1558b0' }, fontWeight: 'bold' }}
                  onClick={() => createGdriveFullBackup(false)}
                  disabled={gdriveFullRunning || creatingBackup || creatingFullBackup || gdriveRunning}
                  startIcon={gdriveFullRunning ? <CircularProgress size={16} color="inherit" /> : <GDriveIcon />}
                >
                  {gdriveFullRunning
                    ? (gdriveFullRunProgress?.message || 'Processando...')
                    : 'Backup Completo → Google Drive'}
                </Button>

                {gdriveFullRunning && gdriveFullRunProgress && (
                  <Box sx={{ mt: 0.5 }}>
                    <LinearProgress
                      variant="determinate"
                      value={Math.min(gdriveFullRunProgress.percent || 0, 100)}
                      sx={{ height: 8, borderRadius: 3 }}
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block', textAlign: 'center' }}>
                      {gdriveFullRunProgress.status === 'uploading' ? 'Enviando ao Drive...' : 'Criando backup...'}
                      {' '}{(gdriveFullRunProgress.percent || 0).toFixed(2)}%
                      {gdriveFullRunProgress.done_count != null && gdriveFullRunProgress.total_count != null && (
                        <> &nbsp;·&nbsp; {gdriveFullRunProgress.done_count}/{gdriveFullRunProgress.total_count} arquivos</>
                      )}
                    </Typography>
                  </Box>
                )}

              </>
            )}


            <Box sx={{ mt: 1, p: 1.5, bgcolor: '#f0f4ff', borderRadius: 1, border: '1px solid #c5cae9', textAlign: 'center' }}>
              {(gdriveRunning || gdriveFullRunning) ? (
                <Typography variant="caption" sx={{ color: '#1565c0', fontWeight: 500 }}>
                  Backup em andamento:{' '}
                  {((gdriveFullRunning ? gdriveFullRunProgress?.percent : gdriveRunProgress?.percent) || 0).toFixed(2)}%
                </Typography>
              ) : gdriveFiles.length > 0 ? (
                <Typography variant="caption" color="text.secondary">
                  Último backup no Drive:{' '}
                  {(() => {
                    const sorted = [...gdriveFiles].sort((a, b) => new Date(b.ModTime) - new Date(a.ModTime));
                    const d = new Date(sorted[0].ModTime);
                    return d.toLocaleDateString('pt-BR') + ' às ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
                  })()}
                </Typography>
              ) : (
                <Typography variant="caption" color="text.secondary">
                  Nenhum backup no Drive ainda
                </Typography>
              )}
            </Box>

            <Divider sx={{ my: 1 }} />
            <Button
              variant="outlined"
              color="warning"
              onClick={openImportDialog}
              startIcon={<CloudUploadIcon />}
              fullWidth
            >
              Importar / Restaurar Backup
            </Button>
          </Box>

          {/* ─── Seção API Diário de Obra (isolado) ─── */}
          <Box sx={{ mb: 2, p: 1.5, bgcolor: 'rgba(67,160,71,0.05)', borderRadius: 1, border: '1px solid rgba(67,160,71,0.2)' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#2e7d32' }}>
              📡 Backup API (Diário de Obra)
            </Typography>
            <Button
              variant="contained"
              sx={{ bgcolor: '#43a047', '&:hover': { bgcolor: '#2e7d32' } }}
              onClick={createApiBackup}
              disabled={creatingApiBackup || gdriveApiRunning}
              startIcon={creatingApiBackup ? <CircularProgress size={16} color="inherit" /> : <CloudSyncIcon />}
              fullWidth
            >
              {creatingApiBackup
                ? (apiBackupCurrentPart > 0 ? `Processando parte ${apiBackupCurrentPart}/5...` : 'Iniciando backup...')
                : 'Criar Backup API (Diário de Obra)'}
            </Button>

            {gdriveStatus?.configured && (
              <Button
                variant="contained"
                fullWidth
                sx={{ bgcolor: '#1a73e8', '&:hover': { bgcolor: '#1558b0' }, fontWeight: 'bold', mt: 0.5 }}
                onClick={createGdriveApiBackup}
                disabled={gdriveApiRunning || creatingApiBackup}
                startIcon={gdriveApiRunning ? <CircularProgress size={16} color="inherit" /> : <GDriveIcon />}
              >
                {gdriveApiRunning
                  ? (gdriveApiRunProgress?.message || 'Processando...')
                  : 'Backup API → Google Drive'}
              </Button>
            )}

            {gdriveApiRunning && gdriveApiRunProgress && (
              <Box sx={{ mt: 0.5 }}>
                <LinearProgress
                  variant="determinate"
                  value={Math.min(gdriveApiRunProgress.percent || 0, 100)}
                  sx={{ height: 8, borderRadius: 3 }}
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block', textAlign: 'center' }}>
                  {gdriveApiRunProgress.status === 'uploading' ? 'Enviando ao Drive...' : 'Baixando dados da API...'}
                  {' '}{(gdriveApiRunProgress.percent || 0).toFixed(2)}%
                </Typography>
              </Box>
            )}

            {/* Progresso do backup API */}
            {apiProgress && apiProgress.status === 'running' && (
              <Box sx={{ mt: 1, p: 1.5, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <CircularProgress size={14} />
                  <Typography variant="caption" color="text.secondary">
                    Backup em andamento — {(apiProgress.parts || []).filter(p => p.status === 'completed').length}/{apiProgress.total_parts || 5} partes
                  </Typography>
                </Box>
                <LinearProgress 
                  variant="determinate" 
                  value={((apiProgress.parts || []).filter(p => p.status === 'completed').length / (apiProgress.total_parts || 5)) * 100}
                  sx={{ height: 6, borderRadius: 3 }}
                />
                <Box sx={{ display: 'flex', gap: 0.5, mt: 1, flexWrap: 'wrap' }}>
                  {(apiProgress.parts || []).map((p, i) => (
                    <Chip
                      key={i}
                      label={`P${i + 1}`}
                      size="small"
                      color={p.status === 'completed' ? 'success' : p.status === 'running' ? 'primary' : p.status === 'error' ? 'error' : 'default'}
                      variant={p.status === 'running' ? 'outlined' : 'filled'}
                      sx={{ fontSize: '0.7rem', height: 20 }}
                    />
                  ))}
                </Box>
              </Box>
            )}

            {/* Relatório de erros do último backup */}
            {apiProgress && apiProgress.global_errors && apiProgress.global_errors.length > 0 && apiProgress.status !== 'running' && (
              <Box sx={{ mt: 1, p: 1.5, bgcolor: '#fff3e0', borderRadius: 1, maxHeight: 150, overflow: 'auto' }}>
                <Typography variant="caption" color="warning.dark" fontWeight="bold">
                  Relatório de erros ({apiProgress.global_errors.length}):
                </Typography>
                {apiProgress.global_errors.slice(0, 20).map((err, i) => (
                  <Typography key={i} variant="caption" display="block" color="text.secondary" sx={{ fontSize: '0.7rem', ml: 1 }}>
                    • {err}
                  </Typography>
                ))}
                {apiProgress.global_errors.length > 20 && (
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', ml: 1, fontStyle: 'italic' }}>
                    ... e mais {apiProgress.global_errors.length - 20} erro(s)
                  </Typography>
                )}
              </Box>
            )}
          </Box>
          
          {/* Lista de backups normais */}
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
            Backups (DB + Uploads):
          </Typography>
          <List sx={{ maxHeight: 200, overflow: 'auto', mb: 2 }}>
            {backups.map((b) => (
              <ListItem
                key={b.id}
                dense
                disableGutters
                sx={{ 
                  borderBottom: '1px solid #eee',
                  py: 1,
                }}
                secondaryAction={
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Baixar">
                      <IconButton 
                        size="small" 
                        color="primary"
                        onClick={() => downloadBackup(b.id, b.filename)}
                        disabled={downloadingBackup === b.id}
                      >
                        {downloadingBackup === b.id ? (
                          <CircularProgress size={18} />
                        ) : (
                          <DownloadIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Tooltip>
                    {gdriveStatus?.configured && (
                      <Tooltip title="Enviar ao Google Drive">
                        <IconButton
                          size="small"
                          sx={{ color: '#1565c0' }}
                          onClick={() => gdriveUpload(b.filename)}
                          disabled={gdriveUploading === b.filename}
                        >
                          {gdriveUploading === b.filename ? (
                            <CircularProgress size={18} />
                          ) : (
                            <GDriveIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Excluir">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => deleteBackup(b.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Checkbox
                      edge="end"
                      size="small"
                      checked={selectedFiles.has(b.id)}
                      onChange={() => toggleFile(b.id)}
                    />
                  </Box>
                }
              >
                <ListItemText
                  primary={b.filename}
                  secondary={`${formatDateTimeBr(b.created_at)} • ${b.size_human}`}
                />
              </ListItem>
            ))}
            {!backups.length && (
              <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
                Nenhum backup encontrado.
              </Typography>
            )}
          </List>
          
          {/* Lista de backups completos */}
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
            Backups Completos (Frontend + Backend + DB):
          </Typography>
          <List sx={{ maxHeight: 200, overflow: 'auto' }}>
            {fullBackups.map((b) => (
              <ListItem
                key={b.id}
                dense
                disableGutters
                sx={{ 
                  borderBottom: '1px solid #eee',
                  py: 1,
                  bgcolor: 'rgba(156, 39, 176, 0.05)',
                }}
                secondaryAction={
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Chip label="Completo" size="small" color="secondary" sx={{ mr: 1 }} />
                    <Tooltip title="Baixar">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => downloadBackup(b.id, b.filename)}
                        disabled={downloadingBackup === b.id}
                      >
                        {downloadingBackup === b.id ? (
                          <CircularProgress size={18} />
                        ) : (
                          <DownloadIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Tooltip>
                    {gdriveStatus?.configured && (
                      <Tooltip title="Enviar ao Google Drive">
                        <IconButton
                          size="small"
                          sx={{ color: '#1565c0' }}
                          onClick={() => gdriveUpload(b.filename)}
                          disabled={gdriveUploading === b.filename}
                        >
                          {gdriveUploading === b.filename ? (
                            <CircularProgress size={18} />
                          ) : (
                            <GDriveIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Excluir">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => deleteBackup(b.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                }
              >
                <ListItemText
                  primary={b.filename}
                  secondary={`${formatDateTimeBr(b.created_at)} • ${b.size_human}`}
                />
              </ListItem>
            ))}
            {!fullBackups.length && (
              <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
                Nenhum backup completo encontrado.
              </Typography>
            )}
          </List>
          
          {/* Lista de backups da API */}
          <Typography variant="subtitle2" sx={{ mb: 1, mt: 2, fontWeight: 'bold' }}>
            Backups API (Diário de Obra):
          </Typography>

          {/* Progresso das 5 partes do backup API */}
          {apiProgress && (
            <Box sx={{ mb: 2, p: 1.5, bgcolor: 'rgba(67,160,71,0.07)', borderRadius: 1 }}>
              <Typography variant="caption" sx={{ fontWeight: 'bold', mb: 0.5, display: 'block' }}>
                Progresso ({apiProgress.date || '—'}):
              </Typography>
              <Box sx={{ display: 'flex', gap: 0.5, mb: 0.5 }}>
                {[0, 1, 2, 3, 4].map((idx) => {
                  const partData = apiProgress.parts && apiProgress.parts[idx];
                  const done = partData && partData.status === 'completed';
                  const hasError = partData && partData.status === 'error';
                  const running = creatingApiBackup && apiBackupCurrentPart === idx + 1;
                  return (
                    <Chip
                      key={idx}
                      label={`P${idx + 1}`}
                      size="small"
                      sx={{
                        bgcolor: done ? '#43a047' : hasError ? '#d32f2f' : running ? '#ff9800' : '#bdbdbd',
                        color: '#fff',
                        fontWeight: 'bold',
                        minWidth: 44,
                        animation: running ? 'pulse 1s infinite' : 'none',
                        '@keyframes pulse': { '50%': { opacity: 0.6 } },
                      }}
                    />
                  );
                })}
              </Box>
              {apiProgress.parts && apiProgress.parts.map((v, idx) => (
                v.status === 'completed' && (
                  <Typography key={idx} variant="caption" color="text.secondary" display="block">
                    Parte {idx + 1}: {v.obras_count || 0} obras • {v.fotos || 0} fotos, {v.videos || 0} vídeos, {v.pdfs || 0} PDFs
                    {v.observacoes && <span style={{ color: '#d32f2f' }}> • Obs: {v.observacoes}</span>}
                  </Typography>
                )
              ))}
              {apiProgress.parts && apiProgress.parts.map((v, idx) => (
                v.status === 'error' && (
                  <Typography key={`err-${idx}`} variant="caption" sx={{ color: '#d32f2f', display: 'block' }}>
                    ✗ Parte {idx + 1}: {v.observacoes || 'Erro desconhecido'}
                  </Typography>
                )
              ))}
              {apiProgress.final_zip && (
                <Typography variant="caption" sx={{ color: '#43a047', fontWeight: 'bold', mt: 0.5, display: 'block' }}>
                  ✓ ZIP final: {apiProgress.final_zip}
                </Typography>
              )}
            </Box>
          )}
          <List sx={{ maxHeight: 200, overflow: 'auto' }}>
            {apiBackups.map((b) => (
              <ListItem
                key={b.id}
                dense
                disableGutters
                sx={{ 
                  borderBottom: '1px solid #eee',
                  py: 1,
                  bgcolor: 'rgba(67, 160, 71, 0.05)',
                }}
                secondaryAction={
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Chip label="API" size="small" sx={{ mr: 1, bgcolor: '#43a047', color: '#fff' }} />
                    <Tooltip title="Baixar">
                      <IconButton 
                        size="small" 
                        color="primary"
                        onClick={() => downloadBackup(b.id, b.filename)}
                        disabled={downloadingBackup === b.id}
                      >
                        {downloadingBackup === b.id ? (
                          <CircularProgress size={18} />
                        ) : (
                          <DownloadIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton 
                        size="small" 
                        color="error"
                        onClick={() => deleteBackup(b.id)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                }
              >
                <ListItemText
                  primary={b.filename}
                  secondary={`${formatDateTimeBr(b.created_at)} • ${b.size_human}`}
                />
              </ListItem>
            ))}
            {!apiBackups.length && (
              <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
                Nenhum backup da API encontrado.
              </Typography>
            )}
          </List>

          {/* === Google Drive === */}
          <Divider sx={{ my: 2 }} />
          <Box sx={{ mb: 1, p: 1.5, bgcolor: 'rgba(66,133,244,0.05)', borderRadius: 1, border: '1px solid rgba(66,133,244,0.2)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
              <GDriveIcon sx={{ color: '#1565c0', fontSize: 20 }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1565c0', flex: 1 }}>
                Google Drive
              </Typography>
              {gdriveStatus?.configured && (
                <Chip label="Conectado" color="success" size="small" />
              )}
            </Box>

            {gdriveMessage && (
              <Typography variant="caption" color="success.main" sx={{ display: 'block', mb: 1 }}>
                ✓ {gdriveMessage}
              </Typography>
            )}
            {gdriveError && (
              <Typography variant="caption" color="error" sx={{ display: 'block', mb: 1 }}>
                ✗ {gdriveError}
              </Typography>
            )}

            {!gdriveStatus?.configured ? (
              <Box>
                {!gdriveStatus?.rclone_available && gdriveStatus !== null && (
                  <Alert severity="warning" sx={{ mb: 1.5 }}>
                    rclone não está instalado no servidor.
                  </Alert>
                )}
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                  Envie backups diretamente para o Google Drive via rclone. Configure o rclone no servidor uma vez e pronto.
                </Typography>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => { setGdriveSetupOpen(true); setGdriveError(''); setGdriveMessage(''); }}
                  fullWidth
                  size="small"
                  startIcon={<GDriveIcon />}
                >
                  Configurar Google Drive (rclone)
                </Button>
              </Box>
            ) : (
              <Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                  Remote: <strong>{gdriveStatus.remote}</strong> → pasta: <strong>{gdriveStatus.folder}</strong>
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ bgcolor: '#1565c0', '&:hover': { bgcolor: '#0d47a1' }, flex: 1 }}
                    onClick={gdriveUploadLatest}
                    disabled={!!gdriveUploading}
                    startIcon={gdriveUploading ? <CircularProgress size={14} color="inherit" /> : <CloudSyncIcon />}
                  >
                    {gdriveUploading ? 'Enviando...' : 'Enviar Último Backup'}
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => { setGdriveSetupOpen(true); setGdriveError(''); }}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={gdriveDisconnect}
                  >
                    Remover
                  </Button>
                </Box>

                {gdriveFiles.length > 0 && (
                  <>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                      Backups no Drive ({gdriveFiles.length}):
                    </Typography>
                    <List dense sx={{ maxHeight: 140, overflow: 'auto', bgcolor: '#fff', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                      {gdriveFiles.map((f) => (
                        <ListItem key={f.ID || f.Name} dense disableGutters sx={{ px: 1 }}>
                          <ListItemText
                            primary={f.Name || f.name}
                            primaryTypographyProps={{ variant: 'caption' }}
                            secondary={f.Size ? `${(f.Size / 1024 / 1024).toFixed(1)} MB` : ''}
                            secondaryTypographyProps={{ variant: 'caption' }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}
                {gdriveFiles.length === 0 && (
                  <Typography variant="caption" color="text.secondary">
                    Nenhum backup encontrado no Drive ainda.
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (selectedFiles.size > 0) {
                selectedFiles.forEach(id => deleteBackup(id));
                setSelectedFiles(new Set());
              }
            }}
            variant="contained"
            color="error"
            disabled={!selectedFiles.size}
            size="small"
          >
            Excluir selecionados ({selectedFiles.size})
          </Button>
          <Button onClick={() => setBackupsModalOpen(false)} variant="outlined">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Configuração Google Drive (via rclone) */}
      <Dialog open={gdriveSetupOpen} onClose={() => setGdriveSetupOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <GDriveIcon sx={{ color: '#1565c0' }} />
          Configurar Google Drive (rclone)
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            O <strong>rclone</strong> deve estar instalado e configurado no servidor VPS antes de continuar.
          </Alert>

          <Typography variant="body2" sx={{ mb: 0.5 }}><strong>1. Instalar rclone no servidor:</strong></Typography>
          <Box sx={{ bgcolor: '#1e1e1e', borderRadius: 1, p: 1.5, mb: 2, fontFamily: 'monospace', fontSize: 12, color: '#d4d4d4', overflowX: 'auto' }}>
            curl https://rclone.org/install.sh | sudo bash
          </Box>

          <Typography variant="body2" sx={{ mb: 0.5 }}><strong>2. Configurar o remote do Google Drive:</strong></Typography>
          <Box sx={{ bgcolor: '#1e1e1e', borderRadius: 1, p: 1.5, mb: 1, fontFamily: 'monospace', fontSize: 12, color: '#d4d4d4' }}>
            rclone config
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
            Escolha: n (new remote) → nome: <strong>gdrive</strong> → tipo: <strong>drive</strong> → siga o fluxo OAuth no navegador
          </Typography>

          <Typography variant="body2" sx={{ mb: 0.5 }}><strong>3. Verificar a conexão:</strong></Typography>
          <Box sx={{ bgcolor: '#1e1e1e', borderRadius: 1, p: 1.5, mb: 2, fontFamily: 'monospace', fontSize: 12, color: '#d4d4d4' }}>
            rclone ls gdrive:
          </Box>

          <Divider sx={{ my: 2 }} />
          <Typography variant="body2" sx={{ mb: 1 }}><strong>4. Informe os dados abaixo:</strong></Typography>

          <TextField
            label="Nome do remote (ex: gdrive)"
            value={gdriveRemote}
            onChange={(e) => setGdriveRemote(e.target.value)}
            fullWidth
            size="small"
            sx={{ mb: 1.5 }}
            helperText="O nome que você usou no 'rclone config'"
          />
          <TextField
            label="Pasta de destino no Drive"
            value={gdriveFolder}
            onChange={(e) => setGdriveFolder(e.target.value)}
            fullWidth
            size="small"
            helperText="Será criada automaticamente se não existir"
          />

          {gdriveError && (
            <Alert severity="error" sx={{ mt: 2 }}>{gdriveError}</Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setGdriveSetupOpen(false); setGdriveError(''); }}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={gdriveSetup}
            disabled={!gdriveRemote.trim() || gdriveSettingUp}
            startIcon={gdriveSettingUp ? <CircularProgress size={16} color="inherit" /> : <GDriveIcon />}
          >
            {gdriveSettingUp ? 'Verificando...' : 'Salvar e Conectar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Importação de Backup */}
      <Dialog
        open={importDialogOpen}
        onClose={closeImportDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {importStep === 1 && 'Importar Backup - Autenticação'}
          {importStep === 2 && 'Importar Backup - Confirmar Data'}
          {importStep === 3 && 'Importar Backup - Confirmação Final'}
          {importStep === 4 && 'Importação Concluída'}
        </DialogTitle>
        <DialogContent>
          {/* Passo 1: Senha de admin e seleção de arquivo */}
          {importStep === 1 && (
            <Box sx={{ py: 2 }}>
              <Alert severity="warning" sx={{ mb: 3 }}>
                <strong>Atenção!</strong> A restauração de backup irá substituir todos os dados atuais do sistema.
                Esta ação não pode ser desfeita.
              </Alert>
              
              <Typography variant="body2" sx={{ mb: 2 }}>
                Selecione o arquivo de backup (.zip) e digite a senha de administrador para continuar:
              </Typography>
              
              <input
                type="file"
                accept=".zip"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileSelect}
              />
              
              <Button
                variant="outlined"
                onClick={() => fileInputRef.current?.click()}
                fullWidth
                sx={{ mb: 2 }}
              >
                {importFile ? `Arquivo: ${importFile.name}` : 'Selecionar arquivo de backup (.zip)'}
              </Button>
              
              {importMetadata && (
                <Alert severity="info" sx={{ mb: 2 }}>
                  Backup válido! Data: <strong>{importMetadata.backup_date_formatted}</strong>
                  {importMetadata.type === 'full' && <Chip label="Completo" size="small" color="secondary" sx={{ ml: 1 }} />}
                </Alert>
              )}
              
              <TextField
                label="Senha de Administrador"
                type="password"
                value={importPassword}
                onChange={(e) => setImportPassword(e.target.value)}
                fullWidth
                error={!!importPasswordError}
                helperText={importPasswordError}
                sx={{ mb: 2 }}
              />
            </Box>
          )}
          
          {/* Passo 2: Confirmar data do backup */}
          {importStep === 2 && importMetadata && (
            <Box sx={{ py: 2 }}>
              <Alert severity="warning" sx={{ mb: 3 }}>
                <Typography variant="body1">
                  Deseja realizar a importação de backup do dia <strong>{importMetadata.backup_date_formatted}</strong>?
                </Typography>
              </Alert>
              
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                O sistema será restaurado para o estado deste backup. Todos os dados atuais serão substituídos.
              </Typography>
            </Box>
          )}
          
          {/* Passo 3: Confirmação final - digitar "confirma" */}
          {importStep === 3 && importMetadata && (
            <Box sx={{ py: 2 }}>
              <Alert severity="error" sx={{ mb: 3 }}>
                <Typography variant="body1">
                  <strong>ATENÇÃO FINAL!</strong><br/>
                  Seu sistema irá retornar aos arquivos da data <strong>{importMetadata.backup_date_formatted}</strong>.
                  Você confirma esta ação?
                </Typography>
              </Alert>
              
              <Typography variant="body2" sx={{ mb: 2 }}>
                Para confirmar, digite <strong>"confirma"</strong> no campo abaixo:
              </Typography>
              
              <TextField
                label="Digite 'confirma' para prosseguir"
                value={importConfirmText}
                onChange={(e) => setImportConfirmText(e.target.value)}
                fullWidth
                error={!!importPasswordError}
                helperText={importPasswordError}
                sx={{ mb: 2 }}
              />
              
              {importingBackup && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Restaurando backup...</Typography>
                  <LinearProgress />
                </Box>
              )}
            </Box>
          )}
          
          {/* Passo 4: Sucesso */}
          {importStep === 4 && importResult && (
            <Box sx={{ py: 2 }}>
              <Alert severity="success" sx={{ mb: 3 }}>
                <Typography variant="body1">
                  <strong>Restauração concluída com sucesso!</strong>
                </Typography>
              </Alert>
              
              <Typography variant="body2" sx={{ mb: 2 }}>
                O sistema foi restaurado para a data <strong>{importResult.backup_date_formatted}</strong>.
              </Typography>
              
              <Typography variant="body2" color="text.secondary">
                Itens restaurados:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary={`Banco de dados: ${importResult.restored?.database ? '✓ Restaurado' : '✗ Não encontrado'}`} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={`Uploads: ${importResult.restored?.uploads ? '✓ Restaurado' : '✗ Não encontrado'}`} />
                </ListItem>
              </List>
              
              <Alert severity="info" sx={{ mt: 2 }}>
                Recomendamos recarregar a página para aplicar todas as alterações.
              </Alert>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {importStep === 1 && (
            <>
              <Button onClick={closeImportDialog}>Cancelar</Button>
              <Button
                variant="contained"
                onClick={validatePasswordAndProceed}
                disabled={!importFile || !importMetadata || !importPassword}
              >
                Avançar
              </Button>
            </>
          )}
          {importStep === 2 && (
            <>
              <Button onClick={() => setImportStep(1)}>Voltar</Button>
              <Button
                variant="contained"
                color="warning"
                onClick={() => setImportStep(3)}
              >
                Sim, continuar
              </Button>
            </>
          )}
          {importStep === 3 && (
            <>
              <Button onClick={() => setImportStep(2)} disabled={importingBackup}>Voltar</Button>
              <Button
                variant="contained"
                color="error"
                onClick={executeRestore}
                disabled={importConfirmText.toLowerCase() !== 'confirma' || importingBackup}
              >
                {importingBackup ? 'Restaurando...' : 'Confirmar Restauração'}
              </Button>
            </>
          )}
          {importStep === 4 && (
            <>
              <Button onClick={closeImportDialog}>Fechar</Button>
              <Button
                variant="contained"
                onClick={() => window.location.reload()}
              >
                Recarregar Página
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* Modal de Consulta de Relatórios */}
      <ConsultaRelatoriosModal
        open={openConsultaRelatoriosModal}
        onClose={() => setOpenConsultaRelatoriosModal(false)}
      />

      {/* Modal de Consulta de Chamados */}
      <ConsultaChamadosModal
        open={openConsultaChamadosModal}
        onClose={() => setOpenConsultaChamadosModal(false)}
      />

      {/* Modal de Seleção de Estrutura */}
      <Dialog
        open={openEstruturaDialog}
        onClose={() => setOpenEstruturaDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          Selecione o Módulo
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
            <Card
              sx={{
                display: 'flex',
                alignItems: 'center',
                p: 2,
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': { transform: 'scale(1.02)', bgcolor: 'action.hover' }
              }}
              onClick={() => {
                setOpenEstruturaDialog(false);
                navigate('/estrutura/cadastro-empreiteira');
              }}
            >
              <Avatar sx={{ bgcolor: '#7c3aed', mr: 2, width: 56, height: 56 }}>
                <Storefront fontSize="large" />
              </Avatar>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2, whiteSpace: 'normal' }}>
                  Processo de Cadastro de Empreiteira
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal' }}>
                  Portal público, análise interna, aprovação e conversão opcional em fornecedor
                </Typography>
              </Box>
            </Card>

            <Card
              sx={{
                display: 'flex',
                alignItems: 'center',
                p: 2,
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': { transform: 'scale(1.02)', bgcolor: 'action.hover' }
              }}
              onClick={() => {
                setOpenEstruturaDialog(false);
                setOpenEstruturaSeguranca(true);
              }}
            >
              <Avatar sx={{ bgcolor: theme.palette.secondary.main, mr: 2, width: 56, height: 56 }}>
                <Security fontSize="large" />
              </Avatar>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2, whiteSpace: 'normal' }}>
                  Cadastro de colaborador
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal' }}>
                  EPIs, treinamentos e normas
                </Typography>
              </Box>
            </Card>

            <Card
              sx={{
                display: 'flex',
                alignItems: 'center',
                p: 2,
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': { transform: 'scale(1.02)', bgcolor: 'action.hover' }
              }}
              onClick={() => {
                setOpenEstruturaDialog(false);
                navigate('/locacoes');
              }}
            >
              <Avatar sx={{ bgcolor: '#0ea5e9', mr: 2, width: 56, height: 56 }}>
                <span style={{ fontWeight: 900, fontSize: 18, color: 'white' }}>PTA</span>
              </Avatar>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2, whiteSpace: 'normal' }}>
                  PTA Controle
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal' }}>
                  Locações e máquinas próprias
                </Typography>
              </Box>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEstruturaDialog(false)}>Cancelar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEstruturaSeguranca} onClose={() => setOpenEstruturaSeguranca(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
            Cadastro de colaborador
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Cliente</InputLabel>
              <Select
                value={selectedClienteId}
                label="Cliente"
                onChange={(e) => setSelectedClienteId(e.target.value)}
              >
                <MenuItem value="">
                  <em>Nenhum</em>
                </MenuItem>
                {clientes.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogTitle>
        <DialogContent>
          <EstruturaSeguranca clienteId={selectedClienteId} token={token} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEstruturaSeguranca(false)}>Fechar</Button>
        </DialogActions>
      </Dialog>

      <RecebimentoOSModal
        open={openRecebimentoModal}
        onClose={() => setOpenRecebimentoModal(false)}
        API={API}
        token={token}
      />

      <ConsultaRecebimentoOSModal
        open={openConsultaRecebimentoModal}
        onClose={() => setOpenConsultaRecebimentoModal(false)}
        API={API}
        token={token}
      />

      <AccessLogModal
        open={openAccessLogModal}
        onClose={() => setOpenAccessLogModal(false)}
      />

      <AgendaModal
        open={openAgendaModal}
        onClose={() => setOpenAgendaModal(false)}
      />

      <FluxoCronogramaModal
        open={openFluxoCronogramaModal}
        onClose={() => setOpenFluxoCronogramaModal(false)}
      />

      {/* Modal Abrir Chamado */}
      <Dialog 
        open={openAbrirChamadoModal} 
        onClose={closeAbrirChamadoModal} 
        maxWidth="md" 
        fullWidth
        PaperProps={{ sx: { maxHeight: '90vh' } }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Abrir Chamado
            <Button onClick={closeAbrirChamadoModal} size="small">Fechar</Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          {openAbrirChamadoModal ? (
            <AbrirChamado 
              key={abrirChamadoPrefill?.whatsappMessage?.id || 'manual-dashboard-open'}
              isModal={true}
              initialPrefill={abrirChamadoPrefill}
              onSuccess={() => {
                closeAbrirChamadoModal();
                if (isEmergencyFlow) {
                  setOpenConsultaChamadosModal(true);
                }
                fetchChamadosMetricas();
                fetchEmergenciasPendentes();
              }} 
            />
          ) : null}
        </DialogContent>
      </Dialog>

      <Dialog
        open={openOnlineCheckDialog}
        onClose={() => {}}
        disableEscapeKeyDown
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Sessão Expirada</DialogTitle>
        <DialogContent>
          <Typography>
            Sua sessão expirou por inatividade. Você será redirecionado para fazer login novamente.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" disabled>Processando...</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
